var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import produce from 'immer';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MetadataForm from '~/components/metadata_form';
import Modal from '~/components/modal';
import { useUser } from '~/providers/user';
import { SaveState } from '../../providers/enums';
import { useRightPanel } from '../../providers/right_panel_provider';
const EditMetadataModal = (props) => {
    const { isModalVisible, hideModal, activeDocument } = props;
    const { activeOrganization } = useUser();
    const { updateDocumentMetadata, saveState, updateError } = useRightPanel();
    const { orgMetadata: anyOrgMetadata } = useSelector((state) => state.orgMetadataState);
    const orgMetadata = anyOrgMetadata;
    const [requiredFields, setRequiredFields] = useState([]);
    const [requiredErrors, setRequiredErrors] = useState([]);
    const [metadata, setMetadata] = useState(activeDocument.source.metadataFields);
    useEffect(() => {
        setMetadata(activeDocument.source.metadataFields);
    }, [activeDocument]);
    useEffect(() => {
        if (orgMetadata) {
            setRequiredFields(orgMetadata.reduce((required, orgMetadataField) => {
                if (orgMetadataField.isRequired) {
                    required.push(orgMetadataField.name);
                }
                return required;
            }, []));
        }
    }, [orgMetadata]);
    const handleSave = () => __awaiter(void 0, void 0, void 0, function* () {
        if (requiredErrors.length > 0) {
            return;
        }
        let modifiedMetadata = produce(metadata, draft => {
            const editionDateIndex = draft.findIndex(metadataField => metadataField.name === 'Form Edition Date');
            if (editionDateIndex !== -1) {
                const editionDate = draft[editionDateIndex].value;
                if (typeof editionDate === 'string') {
                    if (editionDate.length === 5) {
                        const splitVal = editionDate.split('-');
                        const century = Number(splitVal[1]) > 22 ? '19' : '20';
                        draft[editionDateIndex].value = `${century}${splitVal[1]}-${splitVal[0]}-01`;
                    }
                    else if (editionDate.length === 7) {
                        draft[editionDateIndex].value = `${editionDate}-01`;
                    }
                    else if (editionDate.length === 10) {
                        draft[editionDateIndex].value = editionDate;
                    }
                }
                else {
                    draft.splice(editionDateIndex, 1);
                }
            }
        });
        modifiedMetadata = modifiedMetadata.filter(metadataField => {
            if (activeOrganization &&
                metadataField.name === 'Company Form Number' &&
                ['Client 1', 'Travelers'].includes(activeOrganization.name))
                return false;
            if (metadataField.value instanceof Array) {
                return metadataField.value.length > 0;
            }
            return metadataField.value !== null &&
                metadataField.value !== undefined &&
                metadataField.value !== '';
        });
        updateDocumentMetadata(activeDocument.id, modifiedMetadata);
    });
    const handleFormChange = (name, value) => {
        setMetadata(produce(metadata, draft => {
            const existingFieldIndex = draft.findIndex(metadataField => metadataField.name === name);
            if (existingFieldIndex !== -1) {
                draft[existingFieldIndex].value = value;
            }
            else {
                draft.push({ name, value });
            }
        }));
    };
    const onHide = () => {
        setMetadata(activeDocument.source.metadataFields);
        hideModal();
    };
    return (React.createElement(Modal, { className: 'metadata-edit-modal', visible: isModalVisible, onHide: onHide },
        React.createElement("div", { className: 'edit-metadata-title' },
            React.createElement("h6", null,
                "Edit Metadata ",
                activeDocument.source.fileName),
            React.createElement("div", null,
                updateError && React.createElement("div", { className: 'error-text' }, updateError),
                React.createElement("button", { className: 'save-metadata', title: 'Save Metadata', disabled: saveState === SaveState.SAVING || requiredErrors.length > 0, onClick: handleSave },
                    saveState !== SaveState.SAVING &&
                        saveState !== SaveState.RECENTLY_SAVED &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fa fa-save' }),
                            " Save"),
                    saveState === SaveState.SAVING &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fas fa-circle-notch fa-spin' }),
                            " Saving..."),
                    saveState === SaveState.RECENTLY_SAVED &&
                        React.createElement("span", null,
                            React.createElement("i", { className: 'fas fa-check' }),
                            " Saved!")))),
        React.createElement("div", { className: 'required-legend' }, "Fields marked with * are required fields"),
        React.createElement("div", { className: 'edit-form' }, orgMetadata && React.createElement(MetadataForm, { orgMetadata: orgMetadata, twoColumns: true, requiredFields: requiredFields, updateRequiredErrors: setRequiredErrors, handleFormChange: handleFormChange, metadata: metadata }))));
};
export default EditMetadataModal;
